import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { AssetsManagementModel, MainAssetModel } from '../asset-management/assets-management.model';
import { AppAPIConfig } from './app-api-config';
import { CommonMessageService } from './common-message.service';
import { HardwareAssetsComponent } from '../asset-management/hardware-assets/hardware-assets.component';

@Injectable({
  providedIn: 'root'
})
export class AssetsManagementService {
  assetsManagementModel: AssetsManagementModel;
  mainAssetModel: MainAssetModel;
  appApi = new AppAPIConfig();
  httpOptions = {};
  httpOptionsForDelete: {};
  httpOptionsForExportToExcel = {};
  httpOptionsForUpload = {};
  constructor(private http: HttpClient, private commonMessageService: CommonMessageService) {
    this.httpOptions = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json',
      }),
      // observe: 'response'
    };

    this.httpOptionsForDelete = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json',
      }),
      body: {},
    };

    this.httpOptionsForExportToExcel = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json',
      }),
      responseType: 'blob'
    };

    this.httpOptionsForUpload = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
      }),
    };
  }

  getAssetsManagementModel() {
    return this.assetsManagementModel;
  }

  setAssetsManagementModel(assetsManagementModel: AssetsManagementModel) {
    console.log('setter method', assetsManagementModel);
    this.assetsManagementModel = assetsManagementModel;
  }

  getMainAssetModel() {
    return this.mainAssetModel;
  }

  setMainAssetModel(mainAssetModel: MainAssetModel) {
    this.mainAssetModel = mainAssetModel;
  }

  refreshHttpOptions() {
    this.httpOptions = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json',
      }),
      // observe: 'response'
    };
    this.httpOptionsForDelete = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json',
      }),
      body: {},
    };

    this.httpOptionsForExportToExcel = {
      headers: new HttpHeaders({
        Authorization: localStorage.getItem('token'),
        'Content-Type': 'application/json',
      }),
      responseType: 'blob'
    };
  }

  getTypeHardwareAssets() {
    return this.http.get(this.appApi.getTypeListAssetsManagementAPI + '/Hardware', this.httpOptions);
  }

  // softwareList;
  getTypeSoftwareAssets() {
    return this.http.get(this.appApi.getTypeListAssetsManagementAPI + '/Software', this.httpOptions);
  }

  getSoftwareAssetsList(branchId, status) {
    return this.http.get<AssetsManagementModel>(this.appApi.getListAssetsManagementAPI + '/Software/' + status + '/' + branchId, this.httpOptions);
  }

  getHardwareAssetsList(branchId, status) {
    return this.http.get<AssetsManagementModel>(this.appApi.getListAssetsManagementAPI + '/Hardware/' + status + '/' + branchId, this.httpOptions);
  }

  assetManagementData;
  addSoftwareAssetsDetails(myFiles, docFile, buttonStatus) {
    this.assetManagementData = this.getAssetsManagementModel();
    console.log('assetmanagementmodel', this.assetManagementData);
    var selecteddateOfPurchase1 = new Date(this.assetManagementData.dateOfPurchase.year + '-' + this.assetManagementData.dateOfPurchase.month + '-' + this.assetManagementData.dateOfPurchase.day);
    var selecteddateOfPurchase2 = moment(selecteddateOfPurchase1).format("YYYY-MM-DD");
    this.assetsManagementModel.dateOfPurchase = selecteddateOfPurchase2;

    if (this.assetsManagementModel.expiryDate) {
      var selectedExpiryDate1 = new Date(this.assetManagementData.expiryDate.year + '-' + this.assetManagementData.expiryDate.month + '-' + this.assetManagementData.expiryDate.day);
      var selectedExpiryDate2 = moment(selectedExpiryDate1).format("YYYY-MM-DD");
      this.assetsManagementModel.expiryDate = selectedExpiryDate2;
    }

    if (this.assetManagementData.dateOfSale) {
      var selectedDateOfSale1 = new Date(this.assetManagementData.dateOfSale.year + '-' + this.assetManagementData.dateOfSale.month + '-' + this.assetManagementData.dateOfSale.day);
      var selectedDateOfSale2 = moment(selectedDateOfSale1).format("YYYY-MM-DD");
      this.assetsManagementModel.dateOfSale = selectedDateOfSale2;
    }

    if (this.assetManagementData.pgbPurchaseAccountingVoucherDate) {
      var selectedpgbPurchaseAccountingVoucherDate1 = new Date(this.assetManagementData.pgbPurchaseAccountingVoucherDate.year + '-' + this.assetManagementData.pgbPurchaseAccountingVoucherDate.month + '-' + this.assetManagementData.pgbPurchaseAccountingVoucherDate.day);
      var selectedpgbPurchaseAccountingVoucherDate2 = moment(selectedpgbPurchaseAccountingVoucherDate1).format("YYYY-MM-DD");
      this.assetsManagementModel.pgbPurchaseAccountingVoucherDate = selectedpgbPurchaseAccountingVoucherDate2;
    }

    if (this.assetManagementData.vendorInvoiceDate) {
      var selectedVendorInvoiceDate1 = new Date(this.assetManagementData.vendorInvoiceDate.year + '-' + this.assetManagementData.vendorInvoiceDate.month + '-' + this.assetManagementData.vendorInvoiceDate.day);
      var selectedVendorInvoiceDate2 = moment(selectedVendorInvoiceDate1).format("YYYY-MM-DD");
      this.assetsManagementModel.vendorInvoiceDate = selectedVendorInvoiceDate2;
    }

    this.assetsManagementModel = this.assetManagementData;
    this.assetsManagementModel.assetType = { id: 2, name: 'Software', subType: [] };
    console.log('assetsmanagementmodel in service', this.assetsManagementModel);
    const data = new Blob([JSON.stringify(this.assetsManagementModel)], {
      type: 'application/json'
    });
    const formData = new FormData();
    for (var i = 0; i < myFiles.length; i++) {
      formData.append('files', myFiles[i]);
    }
    // if (myFiles.length == 0) {
    //   var file = new File([], '');
    //   formData.append('files', file);
    // }
    formData.append('assetRequestModel', data);

    console.log('Save time formData', formData);
    if (buttonStatus == false) {
      this.http.post<AssetsManagementModel>(this.appApi.saveSoftwareAssetAPI + '?fileList=' + docFile, formData, this.httpOptionsForUpload).subscribe((resp: any) => {
        this.commonMessageService.saveMessage();
      });
    }
    else {
      this.http.put<AssetsManagementModel>(this.appApi.updateSoftwareAssetAPI + '?fileList=' + docFile, formData, this.httpOptionsForUpload).subscribe((resp: any) => {
        this.commonMessageService.updateMessage();
      });
    }
  }

  blockSoftwareAssetsDetails(myFiles) {
    this.assetManagementData = this.getAssetsManagementModel();
    const data = new Blob([JSON.stringify(this.assetsManagementModel)], {
      type: 'application/json'
    });
    const formData = new FormData();
    for (var i = 0; i < myFiles.length; i++) {
      formData.append('file', myFiles[i]);
    }
    if (myFiles.length == 0) {
      var file = new File([], '');
      formData.append('file', file);
    }
    formData.append('assetRequestModel', data);
    this.http.put<AssetsManagementModel>(this.appApi.updateSoftwareAssetAPI, formData, this.httpOptionsForUpload).subscribe((resp: any) => {
      // this.commonMessageService.blockMessage();
    });
  }

  executeSoftwareTransfer(transferId, fromSoftware, toSoftware, isRelease, date) {
    this.http.post<AssetsManagementModel>(this.appApi.executeSoftwareTransferAPI + '/' + transferId + '/' + fromSoftware + '/' + toSoftware + '/' + isRelease + '/' + date, {}, this.httpOptions).subscribe((resp: any) => {
      console.log('save software response', resp);
      this.commonMessageService.saveMessage();
    });
  }

  addHardwareAssetsDetails(myFiles, docType, buttonStatus) {
    console.log('service assets data', this.getAssetsManagementModel(), myFiles);
    this.assetsManagementModel = this.getAssetsManagementModel();
    console.log('sale date', this.assetsManagementModel.dateOfSale)
    console.log('retirement date', this.assetsManagementModel.dateOfRetirementOfAsset)

    if (this.assetsManagementModel.dateOfSale) {
      var selectedDateOfSale1 = new Date(this.assetsManagementModel.dateOfSale.year + '-' + this.assetsManagementModel.dateOfSale.month + '-' + this.assetsManagementModel.dateOfSale.day);
      var selectedDateOfSale2 = moment(selectedDateOfSale1).format("YYYY-MM-DD");
      this.assetsManagementModel.dateOfSale = selectedDateOfSale2;
    }

    if (this.assetsManagementModel.dateOfRetirementOfAsset) {
      var selectedDateOfRetirementOfAsset1 = new Date(this.assetsManagementModel.dateOfRetirementOfAsset.year + '-' + this.assetsManagementModel.dateOfRetirementOfAsset.month + '-' + this.assetsManagementModel.dateOfRetirementOfAsset.day);
      var selectedDateOfRetirementOfAsset2 = moment(selectedDateOfRetirementOfAsset1).format("YYYY-MM-DD");
      this.assetsManagementModel.dateOfRetirementOfAsset = selectedDateOfRetirementOfAsset2;
    }


    if (this.assetsManagementModel.dateOfPurchase) {
      var selecteddateOfPurchase1 = new Date(this.assetsManagementModel.dateOfPurchase.year + '-' + this.assetsManagementModel.dateOfPurchase.month + '-' + this.assetsManagementModel.dateOfPurchase.day);
      var selecteddateOfPurchase2 = moment(selecteddateOfPurchase1).format("YYYY-MM-DD");
      this.assetsManagementModel.dateOfPurchase = selecteddateOfPurchase2;
    }

    if (this.assetsManagementModel.vendorInvoiceDate) {
      var selectedVendorInvoiceDate1 = new Date(this.assetsManagementModel.vendorInvoiceDate.year + '-' + this.assetsManagementModel.vendorInvoiceDate.month + '-' + this.assetsManagementModel.vendorInvoiceDate.day);
      var selectedVendorInvoiceDate2 = moment(selectedVendorInvoiceDate1).format("YYYY-MM-DD");
      this.assetsManagementModel.vendorInvoiceDate = selectedVendorInvoiceDate2;
    }

    if (this.assetsManagementModel.pgbPurchaseAccountingVoucherDate) {
      var selectedPGBPurchaseAccountingVoucherDate1 = new Date(this.assetsManagementModel.pgbPurchaseAccountingVoucherDate.year + '-' + this.assetsManagementModel.pgbPurchaseAccountingVoucherDate.month + '-' + this.assetsManagementModel.pgbPurchaseAccountingVoucherDate.day);
      var selectedPGBPurchaseAccountingVoucherDate2 = moment(selectedPGBPurchaseAccountingVoucherDate1).format("YYYY-MM-DD");
      this.assetsManagementModel.pgbPurchaseAccountingVoucherDate = selectedPGBPurchaseAccountingVoucherDate2;
    }
    console.log('date of purchase', this.assetsManagementModel.dateOfPurchase);

    this.assetsManagementModel.assetType = { id: 1, name: 'Hardware', subType: [] };

    const data = new Blob([JSON.stringify(this.assetsManagementModel)], {
      type: 'application/json'
    });
    const formData = new FormData();
    for (var i = 0; i < myFiles.length; i++) {
      formData.append('files', myFiles[i]);
    }

    // if (myFiles.length == 0) {
    //   var file = new File([], '');
    //   formData.append('file', file);
    // }


    // for (var i = 0; i < myFiles1.length; i++) {
    //   formData.append('file', myFiles1[i]);
    // }

    // if (myFiles1.length == 0) {
    //   var file = new File([], '');
    //   formData.append('file', file);
    // }

    // for (var i = 0; i < myFiles2.length; i++) {
    //   formData.append('file', myFiles2[i]);
    // }

    formData.append('assetRequestModel', data);

    console.log('formdata valye for file', formData.get('file'));
    console.log('formdata valye for assets', formData.get('assetRequestModel'));

    if (!buttonStatus) {
      this.http.post<AssetsManagementModel>(this.appApi.saveUpdateHardwareAssetAPI + '?fileList=' + docType, formData, this.httpOptionsForUpload).subscribe((resp: any) => {
        console.log('save software response', resp);
        this.commonMessageService.saveMessage();
      });
    } else {
      this.http.put<AssetsManagementModel>(this.appApi.saveUpdateHardwareAssetAPI + '?fileList=' + docType, formData, this.httpOptionsForUpload).subscribe((resp: any) => {
        this.commonMessageService.updateMessage();
      });
    }
  }

  blockHardwareAssetsDetails(myFiles, docType) {
    this.assetsManagementModel = this.getAssetsManagementModel();
    console.log('in block asase', this.assetsManagementModel);
    // this.assetsManagementModel.assetType = { id: 1, name: 'Hardware', subType: [] };
    const data = new Blob([JSON.stringify(this.assetsManagementModel)], {
      type: 'application/json'
    });
    const formData = new FormData();
    for (var i = 0; i < myFiles.length; i++) {
      formData.append('files', myFiles[i]);
    }
    // if (myFiles.length == 0) {
    //   var file = new File([], '');
    //   formData.append('file', file);
    // }

    // for (var i = 0; i < myFiles1.length; i++) {
    //   formData.append('file', myFiles1[i]);
    // }

    // if (myFiles1.length == 0) {
    //   var file = new File([], '');
    //   formData.append('file', file);
    // }
    formData.append('assetRequestModel', data);

    this.http.put<AssetsManagementModel>(this.appApi.saveUpdateHardwareAssetAPI + '?fileList=' + docType, formData, this.httpOptionsForUpload).subscribe((resp: any) => {
      // this.commonMessageService.updateMessage();
    });
  }

  serviceTagNumberList(type) {
    return this.http.get<AssetsManagementModel>(this.appApi.getServiceTagNumberListAPI + '/' + type, this.httpOptions);
  }

  hardwareServiceTagNumberList(type) {
    return this.http.get<AssetsManagementModel>(this.appApi.getHardwareServiceTagNumberAPI + '/' + type, this.httpOptions);
  }

  gateHardwareServiceTagNumberListForSoftware() {
    return this.http.get<AssetsManagementModel>(this.appApi.getHardwareServiceTagNumberForSoftwareAPI, this.httpOptions);
  }

  transferToUserList() {
    return this.http.get<AssetsManagementModel>(this.appApi.getUserListAPI, this.httpOptions);
  }

  executeHardwareTransfer() {
    this.mainAssetModel = this.getMainAssetModel();
    this.http.post<AssetsManagementModel>(this.appApi.executeHardwareTransferAPI, this.mainAssetModel, this.httpOptions).subscribe((resp: any) => {
      console.log('save software response', resp);
      this.commonMessageService.transferMessage();
    });
  }

  getHardwareTransferRequest() {
    return this.http.get<AssetsManagementModel>(this.appApi.hardwareTransferRequest, this.httpOptions);
  }

  getHardwarePendingRequest() {
    return this.http.get<AssetsManagementModel>(this.appApi.hardwarePendingRequest, this.httpOptions);
  }

  getFromUserPendingRequestDetails() {
    return this.http.get<AssetsManagementModel>(this.appApi.fromUserPendingRequest, this.httpOptions);
  }

  monthlyConfirmAssetDetails() {
    return this.http.get<AssetsManagementModel>(this.appApi.monthlyConfirmAssetDetailsAPI, this.httpOptions);

  }

  physicalVerificationReport(type, branchId, date) {
    return this.http.get<AssetsManagementModel>(this.appApi.physicalVerificationReportAPI + '/' + type + '/' + branchId + '/' + date, this.httpOptions);
  }

  physicalVerificationReportExportToExcel(type, branchId, date) {
    return this.http.get<AssetsManagementModel>(this.appApi.physicalVerificationReportExcelAPI + '/' + type + '/' + branchId + '/' + date, this.httpOptionsForExportToExcel);
  }

  transferSoftwareHistoryReport(branchId, date) {
    return this.http.get<AssetsManagementModel>(this.appApi.transferSoftwareAPI + '/' + branchId + '/' + date, this.httpOptions);
  }

  transferHardwareHistoryReport(branchId, date, serviceTagId) {
    return this.http.get<AssetsManagementModel>(this.appApi.transferHardwareAPI + '/' + branchId + '/' + date + '?assetIds=' + serviceTagId, this.httpOptions);
  }

  softwareHistoryReportExportToExcel(branchId, date) {
    return this.http.get<AssetsManagementModel>(this.appApi.transferSoftwareExcelAPI + '/' + branchId + '/' + date, this.httpOptionsForExportToExcel);
  }

  hardwareHistoryReportExportToExcel(branchId, date, serviceTagId) {
    return this.http.get<AssetsManagementModel>(this.appApi.transferHardwareExcelAPI + '/' + branchId + '/' + date + '?assetIds=' + serviceTagId, this.httpOptionsForExportToExcel);
  }

  approveTransferRequest(transferId, status, reason) {
    return this.http.put<AssetsManagementModel>(this.appApi.approveTransferRequestAPI + '/' + transferId + '/' + status + '?reason=' + reason, {}, this.httpOptions);
  }

  getMonthlyConfirmationPopupDetails() {
    return this.http.get<AssetsManagementModel>(this.appApi.monthlyConfirmationPopupDetailsAPI, this.httpOptions);
  }

  confirmMonthlyTransferRequest(transferAssetId, status, reason) {
    return this.http.post<AssetsManagementModel>(this.appApi.monthlyConfirmationPopupDetailsAPI + '/' + transferAssetId + '/' + status + '?reason=' + reason, {}, this.httpOptions);
  }

  getMonthlyConfirmDetailReport(fyId, date, branchId) {
    return this.http.get<AssetsManagementModel>(this.appApi.assetConfirmationDetailsReportAPI + '/' + fyId + '/' + date + '/' + branchId, this.httpOptions);
  }

  getMonthlyConfirmDetailReportExcel(fyId, date, branchId) {
    return this.http.get<AssetsManagementModel>(this.appApi.assetConfirmationDetailsReportExcelAPI + '/' + fyId + '/' + date + '/' + branchId, this.httpOptionsForExportToExcel);
  }

  getAssetConfirmationDate(fyId) {
    return this.http.get<AssetsManagementModel>(this.appApi.assetConfirmationDateAPI + '/' + fyId, this.httpOptions);
  }

  saveAssetTermsOfUses(assetId) {
    return this.http.post<AssetsManagementModel>(this.appApi.assetTermsOfUsesAPI + '/' + assetId, {}, this.httpOptions);
  }

  getServiceTagByBranch(branchId) {
    return this.http.get<AssetsManagementModel>(this.appApi.serviceTagByBranchAPI + '/' + branchId + '/Hardware', this.httpOptions);
  }
}
